import { configureStore } from "@reduxjs/toolkit";

import workspaceReducer from "./workspaceSlice";
import userReducer from "./userSlice";

export const store = configureStore({
  reducer: {
    workspace: workspaceReducer,
    user: userReducer,
  },
});
